import { Flex } from "@chakra-ui/react";
import { GoChevronRight } from "react-icons/go";

import { InputField } from "./InputField";
import { CustomIconButton } from "../CustomIconButton";

import type { ContactFormStepProps } from "./ContactForm";

export const ContactFormStep2 = ({
	isFinalStep = false,
	setFormStep,
	...fieldProps
}: ContactFormStepProps) => {
	return (
		<Flex gap="4" align="flex-start" w="md">
			<InputField
				label="date + time"
				field="datetime"
				error="when should we meet?"
				isFinalStep={isFinalStep}
				{...fieldProps}
			/>

			<InputField
				label="duration"
				field="duration"
				error="i recommend at least 2 hrs"
				isFinalStep={isFinalStep}
				{...fieldProps}
			/>

			{!isFinalStep && setFormStep && (
				<CustomIconButton
					icon={<GoChevronRight />}
					onClick={() => setFormStep(3)}
				/>
			)}
		</Flex>
	);
};
